import React, { useState } from 'react';
import { __experimentalInputControl as InputControl } from '@wordpress/components';

function ColorName(props) {

    const id = props.idx;
    const [name, setName] = useState();
    const handleChange = ( name ) => props.handleNameChange({idx:id,name:name});
    
    return (
        <>
            <InputControl
                label="Color Name"
                name="name"
                data-index={props.idx}
                type="text"
                value={ name ?? props.name }
                onChange={ ( newName ) => {
                   setName( newName ?? props.name ); 
                   handleChange( newName )
                }}
            />
        </>
    );

}
export default ColorName